// src/components/handoff/ForfeoExploreHandoffLayer.tsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

type HandoffContext = {
  show: boolean;
  title: string;
  subtitle: string;
  cta: string;
  href: string;
};

function buildForfeoComReservationUrl(pathname: string): string {
  const base = 'https://forfeo.com';

  if (pathname.startsWith('/boutique/')) {
    const id = pathname.split('/').filter(Boolean)[1] || 'experience';
    return `${base}/reserver/${encodeURIComponent(id)}?source=forfeoexplore&handoff=boutique_detail`;
  }

  if (pathname.startsWith('/last-call')) {
    return `${base}/reserver/last-call/selection?source=forfeoexplore&handoff=last_call`;
  }

  if (pathname.startsWith('/explorer-plus')) {
    return `${base}/boutique?source=forfeoexplore&handoff=explorer_plus`;
  }

  if (pathname.startsWith('/boutique')) {
    return `${base}/boutique?source=forfeoexplore&handoff=boutique`;
  }

  return `${base}/boutique?source=forfeoexplore&handoff=global`;
}

function getContext(pathname: string): HandoffContext {
  if (pathname.startsWith('/boutique/')) {
    return {
      show: true,
      title: 'Prêt à réserver?',
      subtitle: 'Paiement sécurisé et pass sur Forfeo.com.',
      cta: 'Réserver',
      href: buildForfeoComReservationUrl(pathname),
    };
  }

  if (pathname.startsWith('/last-call')) {
    return {
      show: true,
      title: 'Last Call Forfeo',
      subtitle: 'Réservation officielle sur Forfeo.com.',
      cta: 'Continuer',
      href: buildForfeoComReservationUrl(pathname),
    };
  }

  if (pathname.startsWith('/explorer-plus')) {
    return {
      show: true,
      title: 'Explorer plus',
      subtitle: 'Finalisez sur Forfeo.com ou dans l’app.',
      cta: 'Voir options',
      href: buildForfeoComReservationUrl(pathname),
    };
  }

  return {
    show: false,
    title: '',
    subtitle: '',
    cta: '',
    href: buildForfeoComReservationUrl(pathname),
  };
}

export default function ForfeoExploreHandoffLayer() {
  const location = useLocation();
  const context = getContext(location.pathname);
  const isExplorerPlus = location.pathname.startsWith('/explorer-plus');

  if (!context.show) return null;

  const shellClass = 'hidden';

  return (
    <div className={shellClass}>
      <div className="pointer-events-auto rounded-2xl border border-blue-100 bg-white/94 p-2.5 shadow-[0_20px_60px_rgba(15,23,42,0.18)] backdrop-blur-xl md:p-4">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 md:h-10 md:w-10 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-cyan-400 text-sm font-black text-white shadow-lg">
            F
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-black text-slate-950 leading-tight">{context.title}</p>
            <p className="truncate text-[10px] font-semibold text-slate-500 md:text-xs">{context.subtitle}</p>
          </div>
          <a
            href={context.href}
            className="shrink-0 rounded-full bg-slate-950 px-3 py-2 text-[10px] md:px-4 md:text-[11px] font-black uppercase tracking-[0.12em] md:tracking-[0.14em] text-white shadow-lg transition hover:bg-blue-700"
          >
            {context.cta}
          </a>
        </div>
      </div>
    </div>
  );
}
